import { useCallback } from 'react';
import { useTonConnectUI, useTonWallet } from '@tonconnect/ui-react';
import { useTelegram } from '../TelegramProvider';

export const useTonConnect = () => {
    const [tonConnectUI] = useTonConnectUI();
    const wallet = useTonWallet();
    const connected = !!wallet;
    const { hapticFeedback } = useTelegram();

    const connect = useCallback(async () => {
        if (!tonConnectUI) return;
        hapticFeedback?.('light');
        await tonConnectUI.openModal();
    }, [tonConnectUI, hapticFeedback]);

    const disconnect = useCallback(async () => {
        if (!tonConnectUI) return;
        hapticFeedback?.('medium');
        await tonConnectUI.disconnect();
    }, [tonConnectUI, hapticFeedback]);

    const sendTransaction = useCallback(async (transaction) => {
        if (!tonConnectUI || !connected) throw new Error('Wallet not connected');
        try {
            hapticFeedback?.('light');
        } catch (e) {
            console.warn('Haptic error:', e);
        }
        try {
            const result = await tonConnectUI.sendTransaction(transaction);
            return result;
        } catch (e) {
            console.error('sendTransaction error:', e);
            throw e;
        }
    }, [tonConnectUI, connected, hapticFeedback]);

    return {
        wallet,
        connected,
        isConnecting: false,
        connect,
        disconnect,
        sendTransaction,
    };
};
